import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SuperAdminTable } from '../../../baseComponents/Table';
import { getHumanScribeStatusAction } from '../../../../store/actions';
import { PlusIcon } from 'src/icons';
import { Button } from 'antd';
import { PlusCircleTwoTone } from '@ant-design/icons';
import { getPossibleStatusAction } from 'src/modules/SuperAdmin/store/actions/humanscribe.action';
import OrganizationFilter from '../OrganizationFilter';
import { getFromStorage } from '../../../../../../lib/storage';
import organizationEventEmitter from '../../../../../../utilities/organizationEmmiter';
import AddHumanScribe from './AddHumanScribe';

const HumanScribeStatus = () => {
  const [tableData, setTableData] = useState([]);
  const [tableLoader, setTableLoader] = useState(false);
  const [_editModalOpen, setEditModalOpen] = useState(false);
  const [_selectedHumanScribeKey, setSelectedHumanScribeKey] = useState(null);
  const [_selectedHumanScribeStatus, setSelectedHumanScribeStatus] = useState(
    []
  );
  const [addHumanScribeStatusModalOpen, setAddHumanScribeStatusModalOpen] =
    useState(false);

  const { humanScribeStatus, humanScribeLoading } = useSelector(
    (state) => state.humanScribeState
  );

  //   org
  const { currentPractitioner } = useSelector(
    (state) => state?.practitionerState
  );
  const [_selectedOrganization, setSelectedOrganization] = useState(
    currentPractitioner?.org_name
  );
  const { getActiveOrganizationsList: _getActiveOrganizationsList } =
    useSelector((state) => state?.organizationState);

  const [selectedOrganizationUUID, setSelectedOrganizationUUID] = useState(
    () => {
      const savedOrg = getFromStorage('superAdminSelectedOrganization');
      const parsedSavedOrg = savedOrg ? JSON.parse(savedOrg) : null;
      return parsedSavedOrg?.org_uuid || currentPractitioner?.org_uuid || null;
    }
  );
  useEffect(() => {
    const unsubscribe = organizationEventEmitter.subscribe(
      'organizationChanged',
      (newOrg) => {
        setSelectedOrganizationUUID(newOrg);
        // handleFilterChange(newOrg);
      }
    );

    return () => unsubscribe();
  }, []);
  console.log(selectedOrganizationUUID);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getHumanScribeStatusAction());
    dispatch(getPossibleStatusAction());
  }, []);

  useEffect(() => {
    const humanScribeStatuss = Object.keys(humanScribeStatus).map((key) => ({
      key: { name: key },
      status: humanScribeStatus[key].map((status) => ({ name: status })),
    }));
    if (humanScribeStatuss) {
      setTableData(humanScribeStatuss);
    }
  }, [humanScribeStatus]);

  useEffect(() => {
    setTableLoader(humanScribeLoading);
  }, [humanScribeLoading]);

  const columns = [
    {
      title: 'Flow',
      render: (text, record) => {
        return <div>{record?.key?.name}</div>;
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      width: '60%',
      render: (text, record) => {
        return (
          <div className="flex flex-wrap gap-2">
            {record?.status?.map((status, index) => {
              return (
                <div
                  key={index}
                  className="flex items-center px-3 py-1 gap-1 mt-2 w-fit rounded-3xl"
                  style={{ border: `1px solid #00D090` }}
                >
                  {status.name}
                </div>
              );
            })}
          </div>
        );
      },
    },
    {
      title: '',
      key: 'actions',
      dataIndex: 'actions',
      // width: '25%',
      render: (text, record) => {
        return (
          <PlusCircleTwoTone
            twoToneColor="#00D090"
            style={{ fontSize: '19px' }}
            onClick={() => {
              handleEditOpen(record);
            }}
          />
        );
      },
    },
  ];

  const handleEditOpen = (record) => {
    setSelectedHumanScribeKey(record?.key);
    setSelectedHumanScribeStatus(record?.status);
    setEditModalOpen(true);
  };

  return (
    <div>
      <div className="flex flex-col sm:flex-row lg:justify-between justify-center items-center">
        <div className="flex flex-col sm:flex-row">
          <div className="flex justify-start gap-12 ">
            <OrganizationFilter />
          </div>
        </div>
        <div className="flex justify-end items-end">
          <Button
            type={'button'}
            onClick={() => {
              setAddHumanScribeStatusModalOpen(true);
            }}
          >
            <PlusIcon className={`mr-2`} /> Add form condition
          </Button>
        </div>
      </div>
      <div className="super-admin-table">
        <div className="mt-5 ant-table rounded-xl shadow-xl">
          <SuperAdminTable
            className={`appointment-page-table`}
            columns={columns}
            data={tableData}
            loading={tableLoader}
          />
        </div>
      </div>
      {addHumanScribeStatusModalOpen && (
        <AddHumanScribe
          isOpen={addHumanScribeStatusModalOpen}
          setIsOpen={setAddHumanScribeStatusModalOpen}
          filterSetSelectedOrganizationUUID={setSelectedOrganizationUUID}
          filterSetSelectedOrganization={setSelectedOrganization}
        />
      )}
    </div>
  );
};

export default HumanScribeStatus;
